var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "treeBody", style: { width: _vm.treeWidth } },
    [
      _vm._t("prefix", [
        _c(
          "div",
          {
            staticStyle: { display: "none", "justify-content": "space-around" },
          },
          [
            _c(
              "el-button",
              {
                staticClass: "mar",
                staticStyle: { color: "#85ce61" },
                attrs: {
                  unauth: "",
                  icon: "el-icon-circle-plus",
                  type: "text",
                  disabled: !_vm.selected,
                },
                on: { click: _vm.addNode },
              },
              [
                _c("span", { staticStyle: { color: "#222222" } }, [
                  _vm._v("新增"),
                ]),
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "mar-u",
                staticStyle: { color: "#ebb563" },
                attrs: {
                  unauth: "",
                  icon: "el-icon-edit",
                  type: "text",
                  disabled: !_vm.selected,
                },
                on: { click: _vm.updateNode },
              },
              [
                _c("span", { staticStyle: { color: "#222222" } }, [
                  _vm._v("编辑"),
                ]),
              ]
            ),
            _c(
              "el-button",
              {
                staticClass: "mar-d",
                staticStyle: { color: "red" },
                attrs: {
                  unauth: "",
                  icon: "el-icon-delete",
                  type: "text",
                  disabled: !_vm.selected,
                },
                on: { click: _vm.deleteNode },
              },
              [
                _c("span", { staticStyle: { color: "#222222" } }, [
                  _vm._v("删除"),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm.filter
        ? _c("el-input", {
            staticClass: "input",
            attrs: { size: "small", placeholder: "关键字过滤" },
            model: {
              value: _vm.filterText,
              callback: function ($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText",
            },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticStyle: {
            "overflow-x": "hidden",
            "flex-grow": "1",
            position: "relative",
          },
        },
        [
          _c(
            "div",
            { staticClass: "ice-full-absolute" },
            [
              _c(
                "vue-scroll",
                {
                  staticStyle: { "overflow-x": "auto" },
                  attrs: { ops: _vm.ops },
                },
                [
                  _vm.isLazy
                    ? _c(
                        "el-tree",
                        _vm._b(
                          {
                            ref: "tree",
                            attrs: {
                              props: _vm.defaultProps,
                              "node-key": _vm.valueProp,
                              lazy: true,
                              load: _vm.load,
                              "show-checkbox": _vm.showTreeCheckbox,
                              "highlight-current": true,
                              "expand-on-click-node": false,
                              "filter-node-method": _vm.filterNode,
                            },
                            on: {
                              "current-change": _vm.handleNodeClick,
                              check: _vm.nodeCheck,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var node = ref.node
                                    var data = ref.data
                                    return _c("div", {}, [
                                      _c("i", {
                                        class: node.isLeaf
                                          ? "el-icon-document"
                                          : "el-icon-tickets",
                                        style: {
                                          color: node.isLeaf ? "" : "#ea8784",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "padding-left": "5px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(data[_vm.labelProp]) + " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  },
                                },
                              ],
                              null,
                              false,
                              1163000850
                            ),
                          },
                          "el-tree",
                          _vm.$attrs,
                          false
                        )
                      )
                    : _vm._e(),
                  !_vm.isLazy
                    ? _c(
                        "el-tree",
                        _vm._b(
                          {
                            ref: "tree",
                            attrs: {
                              props: _vm.defaultProps,
                              "node-key": _vm.valueProp,
                              lazy: false,
                              data: _vm.data,
                              "show-checkbox": _vm.showTreeCheckbox,
                              "default-expanded-keys": _vm.defaultExpand,
                              "highlight-current": true,
                              "expand-on-click-node": false,
                              "filter-node-method": _vm.filterNode,
                            },
                            on: {
                              "current-change": _vm.handleNodeClick,
                              check: _vm.nodeCheck,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (ref) {
                                    var node = ref.node
                                    var data = ref.data
                                    return _c("div", {}, [
                                      _c("i", {
                                        class: node.isLeaf
                                          ? "el-icon-document"
                                          : "el-icon-tickets",
                                        style: {
                                          color: node.isLeaf ? "" : "#ea8784",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "padding-left": "5px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(data[_vm.labelProp]) + " "
                                          ),
                                        ]
                                      ),
                                    ])
                                  },
                                },
                              ],
                              null,
                              false,
                              1163000850
                            ),
                          },
                          "el-tree",
                          _vm.$attrs,
                          false
                        )
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }